import type { TranslationTag } from '@ps/web-core-intl';
import { DismissIcon, StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useOnboardingContext } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';
import type { Dispatch } from '@swf/core/store';

import { CashierOnboardingStep } from '../cashierOnboardingStepsInfo';

import { TXTCLI_Back, TXTCLI_Done, TXTINS_Next } from './CashierTourStep.messages.json';
import styles from './CashierTourStep.scss';

const CashierTourStep: React.FC = () => {
  const { activeStep, handleClose, handleBack, handleNext, steps } = useOnboardingContext();
  const { localSettings } = useDispatch<Dispatch>();

  return (
    <div className={styles.container}>
      <div className={styles.stepCount}>{`${activeStep + 1}/${steps.length}`}</div>
      <div className={styles.context}>
        <Translation {...(steps[activeStep].context as TranslationTag)} />
      </div>
      <div className={styles.buttonsGroup}>
        {activeStep !== CashierOnboardingStep.StepSummaryPanel && (
          <StarsButton
            className={styles.button}
            variant="secondary"
            onClick={() => handleBack?.()}
            translation={TXTCLI_Back}
          />
        )}
        <StarsButton
          className={styles.button}
          variant="primary"
          onClick={() =>
            handleNext?.(() =>
              localSettings.set({
                cashier: { cashierTour: { onboardingFinished: true, lastModalShown: true } }
              })
            )
          }
          translation={
            activeStep === CashierOnboardingStep.StepCashierPanel ? TXTCLI_Done : TXTINS_Next
          }
        />
      </div>
      <StarsButton
        variant="text"
        size="extra-large"
        className={styles.close}
        icon={<DismissIcon />}
        onClick={() => handleClose?.()}
      />
    </div>
  );
};

export default CashierTourStep;
